// Browser stand-in for node:child_process.
//
// Spawning processes (tools, installers, elevation helpers) is fused off in
// the web build — with one exception: when the renderer's Play button spawns
// a discovered game directory of a curated Steam game, the launch is
// redirected to a steam:// deep link (resolved by preload-web via
// globalThis.__vortexWebLaunch) which the browser hands to the local Steam
// client. The returned fake child mimics a detached process and exits
// cleanly so Vortex's promise chain resolves.
const { EventEmitter } = require("events");

function fusedOff(name) {
    return function () {
        throw new Error(`child_process.${name} is fused off in the web build`);
    };
}

class FakeDetachedProcess extends EventEmitter {
    constructor() {
        super();
        this.pid = -1;
        this.exitCode = null;
        this.stdout = undefined;
        this.stderr = undefined;
        setTimeout(() => {
            this.exitCode = 0;
            this.emit("close", 0, null);
        }, 3000);
    }
    unref() {}
    ref() {}
    kill() {
        return true;
    }
}

function openLaunchUrl(url) {
    // overridable for automated tests (no Steam client in headless Chrome)
    const opener = globalThis.__vortexWebOpenUrl;
    if (typeof opener === "function") {
        opener(url);
        return;
    }
    // The launch runs after the async pre-start deploy hook, so the click's
    // transient user activation has expired — `window.location.assign` to a
    // custom protocol would be silently blocked. A hidden iframe whose src is
    // the protocol URL triggers the OS handler without a top-frame navigation
    // and without the activation requirement.
    try {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        document.body.appendChild(iframe);
        iframe.src = url;
        setTimeout(() => iframe.remove(), 2000);
    } catch (err) {
        // fall back to a top-level navigation if the iframe approach fails
        window.location.href = url;
    }
}

function spawn(command, _args, _options) {
    const launch = globalThis.__vortexWebLaunch;
    const url = launch?.resolveSteamLaunchUrl?.(String(command)) ?? null;
    if (url !== null) {
        console.info(`[vortex-web] redirecting game launch to ${url}`);
        openLaunchUrl(url);
        return new FakeDetachedProcess();
    }
    return fusedOff("spawn")();
}

module.exports = {
    spawn,
    spawnSync: fusedOff("spawnSync"),
    exec: fusedOff("exec"),
    execSync: fusedOff("execSync"),
    execFile: fusedOff("execFile"),
    execFileSync: fusedOff("execFileSync"),
    fork: fusedOff("fork"),
};
